import { fileNameValidationErrorTextMap } from '@shared/validators';

/** ERM-12396/12397 Replace Document dialog title. */
export const REPLACE_DOCUMENT_DIALOG_TITLE = 'Replace Document';

/**
 * ERM-12317: a replacement is held to the same upload restrictions as a first upload — 1 GB,
 * `defaultAllowedFileTypes`, a 255-character unique name, no forbidden characters — so the
 * dialog defers to the shared `validateFile` rather than pinning its own narrower allow-list.
 *
 * `fileNameValidationErrorTextMap` covers every name-related outcome but not the size one, so
 * that message lives here. The AC's "do not mention the constraints in the UI" is why the
 * limit is only ever named in an error, never in the drop zone.
 */
export const REPLACE_FILE_TOO_LARGE_MESSAGE =
  'File exceeds the 1 GB size limit.';

/** Fallback for an unrecognised `validateFile` outcome, so a rejection is never silent. */
export const REPLACE_FILE_INVALID_MESSAGE = 'This file cannot be uploaded.';

/** Error copy for every non-valid `validateFile` outcome, keyed by the outcome it returns. */
export const REPLACE_FILE_ERROR_MESSAGES: Record<string, string> = {
  ...fileNameValidationErrorTextMap('File'),
  fileTooLarge: REPLACE_FILE_TOO_LARGE_MESSAGE,
};
